import { render, staticRenderFns } from "./CampaignsList.vue?vue&type=template&id=0aba5dc6&scoped=true&"
import script from "./CampaignsList.vue?vue&type=script&lang=js&"
export * from "./CampaignsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aba5dc6",
  null
  
)

export default component.exports